/**
 * Search-engine crawlers must never be shown the "desktop only" notice: the app
 * is client-rendered, so a blocked crawler indexes the block page and nothing
 * else. Googlebot Smartphone in particular carries `Android` in its UA string.
 */
const CRAWLER =
  /bot|crawler|spider|crawling|googlebot|bingbot|yandex|duckduckbot|slurp|baiduspider|applebot|petalbot|facebookexternalhit|embedly|whatsapp|telegrambot|twitterbot|discordbot|lighthouse|headlesschrome/i

const PHONE = /Android.*Mobile|iPhone|iPod|Windows Phone|IEMobile/i

/**
 * The terminal needs a physical keyboard, so phones get a notice instead.
 * Tablets (iPad, Android tablets — which omit the `Mobile` token) pass through.
 */
export const isBlockedDevice = (userAgent: string): boolean =>
  !CRAWLER.test(userAgent) && PHONE.test(userAgent)
